<template>
  <div class="mt-10">
    <div class="d-flex align-center justify-space-between">
      <div class="text-4">Superfluid Pools</div>
      <c-btn
        :widthPersistent="false"
        is-small
        v-if="!grantStatus.granted"
        @click="showTx('grantLpAutocompound')"
        >Grant Authz</c-btn
      >
      <c-btn
        :widthPersistent="false"
        is-small
        v-else
        @click="showTx('revokeLpAutocompound')"
        is-default
        >Revoke Authz</c-btn
      >
    </div>
    <div
      class="mt-4 d-flex align-center bg-stake-lighter has-border border-stake rounded-8 gray--text text-6 font-weight-medium px-6 py-2"
    >
      <div class="flex-1">Pool</div>
      <div class="flex-1 d-flex align-center">
        <div class="flex-1 text-right">Shares</div>
        <div class="flex-1 d-flex align-center justify-end ml-2 ml-sm-0">
          <div>AutoCompounded</div>
          <v-tooltip bottom color="dark" max-width="260px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                >mdi-information</v-icon
              >
            </template>
            <span
              >If you are in multiple pools that generate the same token, your amount compounded to each pool will be relative to your shares.</span
            >
          </v-tooltip>
        </div>
      </div>
    </div>
    <div
      class="mt-4 d-flex align-center px-6 text-5"
      v-for="item in lockItems"
      :key="item.lockId"
    >
      <v-tooltip top color="dark">
        <template v-slot:activator="{ on, attrs }">
          <a
            v-bind="attrs"
            v-on="on"
            class="flex-1 text-decoration-underline-hover black--text"
            :href="`https://app.osmosis.zone/pool/${item.pool.id}`"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="font-weight-medium">{{ item.pool.symbols }}</div>
            <div class="mt-1 text-6">Pool #{{ item.pool.id }}</div>
          </a>
        </template>
        <div>Click to see pool's details.</div>
      </v-tooltip>
      <div class="flex-1 d-flex align-center">
        <div class="flex-1 text-right">
          {{ (item.shares / 1e18) | denomFormat("0,0.000000", 6) }}
        </div>
        <div class="flex-1 d-flex justify-end">
          <v-tooltip
            :disabled="item.delegatedToUs && grantStatus.granted"
            top
            color="dark"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-checkbox
                  hide-details
                  class="mt-0 pt-0"
                  :disabled="!item.delegatedToUs || !grantStatus.granted"
                  v-model="item.autocompounded"
                  @change="updateAutocompoundPools"
                  :indeterminate="!item.delegatedToUs || !grantStatus.granted"
                >
                </v-checkbox>
              </div>
            </template>
            <div v-if="!grantStatus.granted">
              You will need to Grant Authz first.
            </div>
            <div v-else>
              <span v-if="item.shares <= 0">You have no share.</span>
              <span v-else>Your shares are not delegated to StakeWithUs.</span>
            </div>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div class="mt-4 d-flex align-center px-6 text-5">
      <div class="flex-1">
        <a
          href="https://app.osmosis.zone/pools"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-underline-hover"
          >See all pools</a
        >
      </div>
    </div>
    <v-dialog v-model="revokeAuthzDialog" persistent max-width="550">
      <v-card>
        <v-card-title class="text-3"
          >To remove all pools, you will need to Revoke Authz.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="reloadLockItems">Cancel</v-btn>
          <v-btn color="primary" text @click="showTx('revokeLpAutocompound')"
            >Revoke Authz</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      locks: "staking/tendermint/osmosis/autocompoundLocks",
      defaultAutocompoundLocks:
        "staking/tendermint/osmosis/defaultAutocompoundLocks",
      grantStatus: "staking/tendermint/osmosis/grantStatus",
      poolsAutocompound: "staking/tendermint/osmosis/poolsAutocompound",
      blockInfo: "staking/tendermint/blockInfo",
      walletSelected: "userWallets/walletSelected",
    }),
    numsOfUncheckedLock() {
      return this.lockItems.filter(item => item.autocompounded).length;
    },
  },
  methods: {
    showTx(type) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { type, action: "tx" },
      });
      this.revokeAuthzDialog = false;
    },
    updateAutocompoundPools() {
      if (this.numsOfUncheckedLock === 0) {
        this.revokeAuthzDialog = true;
        this.getPoolsAutocompound();
        return;
      }
      this.apTimestamp = new Date().valueOf();
      setTimeout(() => {
        if (this.apTimestamp + 1500 > new Date().valueOf()) return;
        const pools = this.lockItems
          .filter(item => item.autocompounded)
          .map(item => Number(item.pool.id));
        this.$store.dispatch(
          "staking/tendermint/osmosis/requestAutocompoundForPools",
          { pools }
        );
      }, 1500);
    },
    reloadLockItems() {
      this.getPoolsAutocompound();
      this.revokeAuthzDialog = false;
    },
    async getPoolsAutocompound() {
      await this.$store.dispatch(
        "staking/tendermint/osmosis/getPoolsAutocompound"
      );
    },
    normalizeLockItems() {
      const lockItems = JSON.parse(JSON.stringify(this.locks));
      this.lockItems = lockItems.map(item => ({
        ...item,
        autocompounded:
          item.delegatedToUs &&
          this.poolsAutocompound.includes(Number(item.pool.id)),
      }));
    },
  },
  data: () => ({
    lockItems: [],
    apTimestamp: 0,
    revokeAuthzDialog: false,
  }),
  watch: {
    locks: {
      immediate: true,
      handler() {
        this.getPoolsAutocompound();
        this.normalizeLockItems();
      },
    },
    poolsAutocompound: {
      immediate: true,
      handler() {
        this.normalizeLockItems();
      },
    },
    ["walletSelected.address"]: {
      immediate: true,
      handler() {
        this.lockItems = this.defaultAutocompoundLocks;
      },
    },
  },
};
</script>
